import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { RoadTypesParams } from './service';

export enum RoadTypesActions {
  Failure = '[Catalogs RoadTypes] Failure',
  Request = '[Catalogs RoadTypes] Request',
  Success = '[Catalogs RoadTypes] Success',
}

export const RoadTypesFailure = createAction(RoadTypesActions.Failure, props<{ error: HttpErrorResponse }>());

export const RoadTypesRequest = createAction(RoadTypesActions.Request, props<{ parameters?: RoadTypesParams }>());

export const RoadTypesSuccess = createAction(RoadTypesActions.Success, props<{ data: ParameterResult[] }>());
